import React, { Component } from "react";
import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";
import img from "../images/count1.jpg";
import img2 from "../images/count2.jpg";
import "./count.css";
class CountU extends Component {
  state = {
    didViewCountUp: false,
  };

  onVisibilityChange = (isVisible) => {
    if (isVisible) {
      this.setState({ didViewCountUp: true });
    }
  };

  render() {
    return (
      <div className="Count_container">
        <div className="count_inner">
          <div className="inner_container_left_count">
            <img
              src={img}
              alt="countimg"
              className="img_inner_container_count_left"
            />{" "}
            <br />
            <VisibilitySensor onChange={this.onVisibilityChange} delayedCall>
              <>
                <CountUp
                  start={0}
                  end={this.state.didViewCountUp ? 15 : 0}
                  suffix=" +"
                  duration={2.5}
                  style={{
                    fontSize: 46,
                    TextAlign: "center",
                    marginLeft: "43%",
                    color: "black",
                  }}
                />
                <h2>Year of experience</h2>
              </>
            </VisibilitySensor>
          </div>
          <div className="inner_container_right_count">
            <img
              src={img2}
              alt="countimg"
              className="img_inner_container_count_right"
            />{" "}
            <br />
            <VisibilitySensor>
              <>
                <CountUp
                  start={0}
                  end={this.state.didViewCountUp ? 5000 : 0}
                  suffix=" +"
                  duration={0}
                  style={{
                    fontSize: 39,
                    TextAlign: "center",
                    marginLeft: "35%",
                    color: "black",
                  }}
                />
                <h2>Satisfied Patients</h2>
              </>
            </VisibilitySensor>
          </div>
        </div>
      </div>
    );
  }
}

export default CountU;
